import { Directive, ElementRef, Host, HostBinding, HostListener, Self } from '@angular/core';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { AssistantService } from '../common/assistant.service';

/**
 * Direktive, die das zuletzt fokussierte Eingabefeld für den Assistenten abspeichert, um so beim Aufruf des Assistenten
 * zu wissen, welches Feld fokussiert werden soll.
 */
@Directive({
  selector: '[appSaveLastFocussed]'
})
export class SaveLastFocussedDirective {

  @HostListener('focus') saveLastFocussedElement() {
    this.assistantService.setLastFocusedFormField({field: <HTMLElement>this.elementRef.nativeElement, popoverForField: this.popoverForField });
  }

  constructor(private assistantService: AssistantService,
              private elementRef: ElementRef,
              @Self() @Host() private popoverForField: NgbPopover) { }

}
